import React from "react";

import "./style.scss";
import Helmet from "./common/helmet";
import NavBar from "./common/navbar";
import SubMenu from "./common/submenu";
import TrabajaConNosotros from "./layouts/trabajaConNosotros/trabajaConNosotros";
import Footer from "./common/footer";

const Layout = ({ children }) => (
  <div>
    <Helmet />
    <SubMenu />
    <NavBar />
    <TrabajaConNosotros />
    <Footer />
  </div>
);

export default Layout;
